"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  MsOverflowStyle: 'none',
  overflowX: 'scroll',
  overflowY: 'hidden',
  touchAction: 'manipulation',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '& > ul': {
    display: 'flex',
    listStyleType: 'none',
    margin: 0,
    padding: 0
  }
});

var _default = function _default(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react.default.createElement(_Context.default.Consumer, null, function (_ref2) {
    var itemContainerRef = _ref2.itemContainerRef,
        scrollableRef = _ref2.scrollableRef;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(ROOT_CSS + '', className),
      ref: scrollableRef
    }, _react.default.createElement("ul", {
      ref: itemContainerRef
    }, _react.default.Children.map(children, function (child) {
      return _react.default.createElement("li", null, child);
    })));
  });
};

exports.default = _default;